<div mat-dialog-title class="modal-header">
  <div class="css-infwte">
    <h2 class="css-1ihths2">CGV</h2>
  </div>

  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="modal-content" (scroll)="onScroll($event)" #scrollableContent>

  <div>


    <div class="page-break"></div>
    <div>
      <div class="page">
        <style>

        </style>

        <footer>
          Demandes CNIL et RGPD: droit-acces@certinomis.com. Voir les mentions légales de www.certinomis.com<br />
          Certinomis SAS au capital de 40 156 euros. RCS CRETEIL B 433998903 – 45/47 bd Paul Vaillant Couturier – 94200 Ivry-sur-Seine
        </footer>


        <div>
          <p class="b_bottom rubrique text-center">
            CONDITIONS GÉNÉRALES DE VENTE<br />
            <span style="font-weight: 400">GAMME CERTINOMIS CERTIFICATS DISTRIBUÉS</span>
          </p>
        </div>
        <div style="padding: 1rem 0; font-size: 0.62rem; line-height: 1.2; color: #000;">
          <table>
            <tr>
              <td style="vertical-align: top; padding: 0 1rem; width: 50%;">
                <strong>1 &nbsp; OBJET</strong><br />
                1.1 Les présentes Conditions générales ont pour objet de
                préciser le contenu et les modalités de mise en œuvre des
                services de certification proposés par CERTINOMIS ainsi que
                les engagements et obligations respectifs des parties au
                Contrat.<br /><br />

                <strong>2 &nbsp; DEFINITIONS</strong><br />
                <u>2.1 BENEFICIAIRE</u> : La personne physique responsable du
                CERTIFICAT et de son utilisation. Il en est physiquement le
                détenteur et s'engage sur ses conditions d'utilisation et ses
                obligations vis-à-vis de l'Autorité de Certification<br />
                <u>2.2 CERTIFICAT</u> :Attestation électronique émise par
                CERTINOMIS liant les données afférentes au chiffrement ou à
                la vérification de signature des échanges, messages et
                documents électroniques au BENEFICIAIRE, afin d’en assurer
                la confidentialité ou l’authentification et l’intégrité.<br />
                <u>2.3 CLIENT</u> : Organisme, personne morale ou physique qui
                contracte avec CERTINOMIS pour disposer de CERTIFICATS.<br />
                <u>2.4 CONTRAT</u> : ensemble contractuel constitué des présentes
                Conditions Générales de Vente, des Conditions d’Utilisation
                du certificat commandé, du dossier de demande ainsi que de
                la Politique de Certification afférentes figurant sur le site :
                www.certinomis.com applicables à la date de conclusion du
                CONTRAT.<br />
                <u>2.5 MANDATAIRE</u> : Personne qui, directement par la loi ou
                par délégation, a le pouvoir d'autoriser une demande de
                certificat portant le nom de l'organisation. Il peut aussi avoir
                d'autres pouvoirs au nom de l'organisation, comme celui de
                révocation.<br />
                En l’absence de toute désignation expresse du mandataire,
                le représentant légal de l’organisation est considéré comme
                mandataire.<br />
                <u>2.6 SUPPORT</u> : Support physique (carte à cryptoprocesseur ou
                mini CD) contenant notamment le(s) CERTIFICAT(s) du
                BENEFICIAIRE. Le SUPPORT devient la propriété du CLIENT au
                moment de sa mise à disposition par CERTINOMIS.<br />
                <u>2.7 TIERS UTILISATEUR</u> : Personne utilisant le CERTIFICAT
                d’un BENEFICIAIRE afin de vérifier son identité ou de chiffrer
                des messages à son attention.<br /><br />

                <strong>3 &nbsp; DUREE</strong><br />
                3.1 Le CONTRAT est conclu à compter de la réception du
                dossier du CLIENT par CERTINOMIS.<br />
                3.2 Le CONTRAT est conclu pour une durée correspondant à
                la durée de vie du CERTIFICAT.<br /><br />

                <strong>4 &nbsp; PRIX – PAIEMENT DU PRIX</strong><br />
                4.1 Le barème de prix de Certinomis est consultable sur le
                site www.certinomis.com<br />
                4.2 Sauf accord express préalable intervenu avec
                CERTINOMIS, le prix mentionné dans l'offre commerciale est
                payable à la commande.<br />
                4.3 Le CLIENT s'engage, lors du dépôt du dossier
                d'inscription, à payer le prix mentionné suivant les modalités
                convenues.<br />
                4.4 Le CLIENT accepte que CERTINOMIS encaisse le prix
                convenu dès réception de son dossier d'inscription, complet
                ou non.<br />
                4.5 En cas de dossier d'inscription incomplet, à compter de la
                seconde relance auprès du CLIENT restée sans effet dans un
                délai de 15 jours, un montant forfaitaire de 100 € HT par
                demande restera du à CERTINOMIS au titre du traitement de
                sa demande et le solde sera retourné au Client avec son
                dossier de demande incomplet.<br />
                4.6 CERTINOMIS enverra une facture à la réception du
                dossier de demande de CERTIFICAT ainsi que dans le cas
                évoqué à l'article 4.5.<br />
                4.7 Le CLIENT est informé que sa facture est susceptible de
                lui être envoyée au format électronique et signée
                électroniquement par CERTINOMIS. Il accepte par avance de
                recevoir sa facture sous cette forme<br />
                4.8 Le CLIENT conserve la faculté de demander à
                CERTINOMIS de lui envoyer sa facture imprimée sur du papier
                dans les trois mois suivants l'émission de son CERTIFICAT.<br><br>
                <strong>5 &nbsp; MODALITÉ DE DÉLIVRANCE</strong><br />
                5.1 Sauf dérogation figurant dans les conditions
                d’utilisation, les CERTIFICATS seront délivrés sur un
                support (carte à cryptoprocesseur ou mini CD) protégé par
                un code PIN qui sera adressée séparément sous pli scellé au BENEFICIAIRE.<br />
              </td>
              <td style="vertical-align: top; padding: 0 1rem;">

                5.2 Le cas échéant les matériels associés seront adressés
                par courrier séparé.<br />
                5.3 À compter du 30 ème jour suivant la date de validation de
                la demande indiquée dans l’interface de demande de
                Certinomis, le Client est réputé avoir reçu son support et le
                code PIN associé ainsi que les matériels. Aucun envoi
                supplémentaire ne pourra être effectué passé ce délai.<br /><br />
                <strong>6 &nbsp; VALIDITÉ DE L’OFFRE – PRISE D’EFFET DU CONTRAT</strong><br />
                6.1 L’offre est valable à compter du premier jour de sa mise
                en ligne jusqu’au premier jour de la mise en ligne de la
                nouvelle offre. Les conditions générales qui s’appliquent sont
                celles dont la date de mise en ligne figure sur les présentes
                conditions générales.<br />
                6.2 Le CONTRAT entre en vigueur à réception du dossier de
                demande du Client.<br />
                6.3 CERTINOMIS s’engage à répondre à toute demande du
                CLIENT répondant aux conditions générales mises en ligne
                sur le site www.certinomis.com. En tout état de cause,
                CERTINOMIS se réserve la faculté de refuser le traitement de
                toute demande soumise aux Conditions générales qui ne sont
                plus disponibles en ligne sur le site www.certinomis.com.<br /><br />
                <strong>7 &nbsp; CONDITIONS DE RÈGLEMENT</strong><br />
                7.1 Sauf dérogation, les prestations sont payables à la
                commande.<br />
                7.2 Les factures émises par Certinomis sont payables à leur
                réception. À défaut, Certinomis constate le défaut de
                règlement par tout moyen<br />
                7.3 Après deux (2) relances infructueuses, Certinomis se
                réserve le droit de suspendre l’exécution de ses prestations
                et de révoquer le CERTIFICAT concerné.<br />
                7.4 En cas de non-paiement par le Client, de convention
                expresse et sauf report sollicité à temps et spécifiquement
                accordé par Certinomis, le défaut de paiement à l’échéance
                entraîne, de plein droit :<br />
                <table><tr><td style="padding: 0 1rem; vertical-align: top;">-</td><td>La déchéance de tous les termes des créances
                  dues et leur exigibilité immédiate, quel que soit le
                  mode de règlement ayant été prévu;</td></tr></table>
                <table><tr><td style="padding: 0 1rem; vertical-align: top;">-</td><td>La facturation d’un intérêt dû par le seul fait de
                  l’échéance du terme contractuel, représentant une
                  fois et demi le taux d’intérêt légal.</td></tr></table>
                Le taux est calculé prorata temporis par période d’un mois, et
                la somme susvisée est capitalisée au même taux à chaque
                période annuelle.<br />
                Les Parties conviennent que ce taux d’intérêt n’a pas le
                caractère d’une sanction mais est la conséquence du délai
                de paiement accordé de fait par Certinomis au Client.<br /><br />
                <strong>8 &nbsp; ENGAGEMENTS DE CERTINOMIS</strong><br />
                8.1 CERTINOMIS est expressément tenue à une obligation de
                moyen pour toutes les obligations relatives à la gestion du
                cycle de vie du CERTIFICAT qu’elle émet.<br />
                8.2 En cas de dossier incomplet, CERTINOMIS s’engage à
                effectuer une relance auprès du CLIENT dans les quinze (15)
                jours à compter de la réception du dossier d’inscription
                incomplet.<br />
                8.3 A défaut de réponse dans les quinze (15) jours à compter
                de cette première relance, CERTINOMIS s’engage à effectuer
                une seconde relance auprès du CLIENT.<br />
                8.4 CERTINOMIS s’engage à émettre un avis de mise à
                disposition du CERTIFICAT à l’attention du CLIENT qui devra
                se conformer aux procédures décrites dans ledit message
                <br />
                8.5 Dans le cas où la remise s’effectue en face à face, si le
                CLIENT n’a pas retiré son CERTIFICAT dans les quinze (15)
                jours à compter de la réception de l’avis de mise à
                disposition, CERTINOMIS se réserve la faculté de révoquer le
                CERTIFICAT et détruire le support associé.<br />
                Le CLIENT pourra demander à ses frais soit une réémission
                du certificat soit une seconde mise à disposition du certificat
                si celui-ci n’a pas encore été révoqué.<br />
                8.6 CERTINOMIS s’engage à fournir un service de
                consultation en ligne permettant à tout moment de vérifier la
                validité des CERTIFICATS qu’elle a émis, à l’adresse :
                http://www.certinomis.com. CERTINOMIS se réserve
                cependant la faculté de suspendre l’accès au dit site
                lorsqu’elle estime qu’un événement susceptible d’en
                affecter le fonctionnement ou l’intégrité le nécessite, et ce
                pour la durée nécessaire à l’intervention envisagée.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="page-break"></div>
    <div class="page">
      <style>

      </style>

      <footer>
        Demandes CNIL et RGPD: droit-acces@certinomis.com. Voir les mentions légales de www.certinomis.com<br />
        Certinomis SAS au capital de 40 156 euros. RCS CRETEIL B 433998903 – 45/47 bd Paul Vaillant Couturier – 94200 Ivry-sur-Seine
      </footer>
      <div>
        <p class="b_bottom rubrique text-center">
          CONDITIONS GÉNÉRALES DE VENTE<br />
          <span style="font-weight: 400">GAMME CERTINOMIS CERTIFICATS DISTRIBUÉS</span>
        </p>
      </div>
      <div style="padding: 1rem 0; font-size: 0.62rem; line-height: 1.2; color: #000;">
        <table>
          <tr>
            <td style="vertical-align: top; padding: 0 1rem; width: 50%;">

              8.7 CERTINOMIS met à disposition des CLIENTS un service
              technique en ligne minimum consistant en une liste de
              question (« FAQ ») et une messagerie électronique.<br /><br />
              <strong>9 &nbsp; ENGAGEMENTS DU CLIENT</strong><br />
              9.1 Le CLIENT s’engage à adresser par voie postale un
              dossier de demande complet avec toutes les pièces
              justificatives.<br />
              9.2 Le CLIENT s’engage à fournir toutes informations utiles,
              exactes et complètes lors de la demande des CERTIFICATS et
              pendant toute la durée du CONTRAT.<br />
              9.3 Le CLIENT s’engage à notifier sans délai et par écrit
              Certinomis de toute modification d’information signalée
              comme obligatoire lors de l’enregistrement ou du
              renouvellement du CERTIFICAT (notamment, changement de
              mandataire,
              redressement
              judiciaire,
              dissolution,
              liquidation).<br />
              9.4 Toute demande de modification résultante devra être
              accompagnée des justificatifs requis.<br />
              9.5 Le CLIENT s’engage à porter à la connaissance de tous
              ses MANDATAIRES et BENEFICIIARES les conditions
              d’utilisation propres au CERTIFICAT demandé.<br /><br />
              <strong>10 &nbsp; ÉTENDUE DE RESPONSABILITÉ</strong><br />
              <span style="display:block; padding: 0.5rem 0;">10.1 <u>Limitations de responsabilité</u></span>
              10.1.1 CERTINOMIS ne sera en aucun cas tenue
              responsable des éventuels dommages indirects et/ou
              connexes trouvant leur origine ou étant la conséquence du
              CONTRAT ou inhérents à l’utilisation des CERTIFICATS.<br />
              10.1.2 Les parties conviennent qu’en cas de prononcé
              d’une quelconque responsabilité de l’une des parties envers
              l’autre, les dommages, intérêts et indemnités à sa charge,
              toutes causes confondues, ne sauraient en aucun cas
              dépasser la somme de :<br />
              - Cinq cents milles euros (500.000 €) pour un CERTIFICAT
              personnel qualifié sur support cryptographique qualifié
              (carte à puce);<br />
              - Cent cinquante mille euros (150.000 €) pour un
              CERTIFICAT personnel non qualifié ou sans support
              physique ;<br />
              - Trente-huit mille cinq cent euros (38 500 €) pour un
              certificat serveur<br />
              <span style="display:block; padding: 0.5rem 0;">10.2 <u>Exonération de responsabilité</u></span>
              10.2.1 CERTINOMIS n’assume aucun engagement ni
              responsabilité quant à la forme, la suffisance, l’exactitude,
              l’authenticité, la falsification ou l’effet juridique des
              documents remis lors de la demande de CERTIFICAT par le
              CLIENT.<br />
              10.2.2 En aucun cas CERTINOMIS n’intervient, de
              quelque façon que ce soit, dans les relations contractuelles
              qui peuvent se nouer entre les CLIENTS, MANDATAIRES OU
              BENEFICIAIRES et les TIERS UTILISATEURS des dits
              CERTIFICATS.<br />
              10.2.3 CERTINOMIS n’assume aucun engagement ni
              responsabilité quant aux conséquences des retards ou pertes
              que pourraient subir dans leur transmission tous messages
              électroniques, lettres, documents, ni quant aux retards, à
              l’altération ou autres erreurs pouvant se produire dans la
              transmission de toute communication électronique.<br />
              <span style="display:block; padding: 0.5rem 0;">10.3 <u>Force majeure</u></span>
              10.3.1 Une partie ne saurait être tenue responsable pour
              tout retard dans l’exécution de ses obligations ou pour toute
              inexécution de ses obligations résultant des présentes
              conditions générales lorsque les circonstances y donnant lieu
              relèvent de la force majeure au sens de l’article 1148 du
              Code civil.<br />
              10.3.2 Dans un premier temps, les cas de force majeure
              suspendront l’exécution du CONTRAT. Si les cas de force
              majeure ont une durée supérieure à huit (8) jours, les
              conditions générales d’utilisation de services se résilieront
              automatiquement, sauf accord contraire entre les parties.
            </td>
            <td style="vertical-align: top; padding: 0 1rem;">
              <strong>11 &nbsp; RÉSILIATION</strong><br />
              Une partie ne saurait être tenue responsable
              11.1 Au cas où l’une des parties n’exécuterait pas
              l’une des obligations découlant des présentes Conditions
              générales, l’autre partie lui notifiera d’exécuter ladite
              obligation.<br />
              11.2 À défaut pour la partie défaillante d’avoir exécuté
              dans les trente jours de cette notification, l’autre partie
              pourra résilier le CONTRAT sans préjudice des dommages-
              intérêts.<br>
              11.3 Si la partie défaillante exécute dans les trente
              jours, il pourra être tenu au règlement de dommages-intérêts
              de retard.<br />
              11.4 En cas de résiliation anticipée, du CONTRAT
              conclu entre CERTINOMIS et le CLIENT, et quel qu’en soit le
              motif, les sommes acquittées lors de la souscription du
              CONTRAT restent acquises à CERTINOMIS pour toute
              prestation commencée.<br /><br />
              <strong>12 &nbsp; NOTIFICATION ET CONVENTION DE PREUVE</strong><br />
              Dans le cadre des échanges entre les Parties, la date de
              réception du message par le destinataire et la signature de ce
              message valent preuves entre elles et justifient que la
              notification est imputable à la partie émettrice dudit
              message.<br /><br />
              <strong>13 &nbsp; INTÉGRALITÉ DU CONTRAT</strong><br />
              Les parties reconnaissent que les présentes Conditions
              générales, le formulaire de demande de CERTIFICAT et toutes
              les procédures figurant sur le site : www.certinomis.com
              constituent l’intégralité des accords entre elles en ce qui
              concerne la réalisation de l’objet des présentes, et annulent
              et remplacent tous accords et propositions antérieurs ayant
              le même objet quelle qu’en soit la forme.<br /><br />
              <strong>14 &nbsp; CESSION DU CONTRAT</strong><br />
              Le CONTRAT est réputé avoir été conclu en considération de
              la personne du CLIENT. C’est pourquoi le CLIENT s’interdit de
              céder le contrat sans l’accord exprès et préalable de
              CERTINOMIS qui n’a pas à fournir de justification de sa
              décision.<br /><br />
              <strong>15 &nbsp; INDÉPENDANCE DES PARTIES</strong><br />
              D’une façon générale, chacune des parties est une personne
              physique ou morale indépendante juridiquement et
              financièrement, agissant en son nom propre et sous sa seule
              responsabilité.<br /><br />
              <strong>16 &nbsp; RÈGLEMENT DES LITIGES – TRIBUNAL COMPÈTENT</strong><br />
              En cas de litige relatif à l’interprétation, la formation ou
              l’exécution du CONTRAT et faute d’être parvenues à un
              accord amiable, les parties donnent compétence expresse et
              exclusive aux tribunaux compétents de Paris, nonobstant
              pluralité de défendeurs ou d’action en référé ou d’appel en
              garantie ou de mesure conservatoire.<br /><br />
              <strong>17 &nbsp; LOI APPLICABLE</strong><br />
              En cas de litige relatif à l’interprétation, la formation, la
              validité ou l’exécution du CONTRAT, les parties donnent
              compétence expresse et exclusive à la loi française.<br /><br />

              <strong>LA VALIDATION OU LE REGLEMENT DU BON DE COMMANDE
                MANIFESTE LA PRISE DE CONNAISSANCE ET L’ADHESION DU CLIENT
                AUX PRESENTES CONDITIONS GENERALES ET AUX POLITIQUES DE
                CERTIFICATION FIGURANT SUR LE SITE WWW.CERTINOMIS.COM.</strong><br /><br />

            </td>
          </tr>
        </table>
      </div>
    </div>





  </div>


</div>

<div mat-dialog-actions class="modal-footer" style="margin-bottom: 0 !important;">
  <button type="button" class="btn-transparent" mat-dialog-close style="margin-right: 20px;">Fermer</button>
  <button
    type="button"
    class="btn-bleu"
    [disabled]="!scrolledToBottom"
    (click)="acceptCGV()"
  >
    J'ai lu et accepte les CGV
  </button>

</div>
<style>
  .page-break {
    page-break-after: always;
  }
  @page  {
    margin: 60px 25px;
    color: #0076ca;
    color: #003470;
  }

  header {
    position: fixed;
    top: -40px;
    left: 0px;
    right: 0px;
    height: 10px;
    font-size: 0.8rem;

  }
  header p{
    float: left;
    width: 33.33%;
    text-align: center;
  }
  p{
    margin: 0;
  }

  header p:nth-of-type(3){
    text-align: right;
  }

  footer {
    position: fixed;
    bottom: -40px;
    left: 0px;
    right: 0px;
    height: 30px;

    /** Extra personal styles **/
    text-align: center;
    font-size: 0.6rem;
  }
  footer .page {position: absolute; right: 0; }
  footer .page:after { content: counter(page); display: none; }



  .page{
    border: 2px solid #aaa;
    font-size: 0.7rem;
    width: 700px;
    font-family: Helvetica;
    margin-bottom:20px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 0;
    padding-bottom: 0;
    position: relative;
  }

  .title_page{
    padding-left: 25px;
    text-align:left;
    font-size: 1.5rem;
    font-weight: bold;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }


  .b_bottom{
    border-bottom: 1px solid #aaa;
  }
  .fields{
    padding: 0.3rem 0 0.2rem;
  }
  .barcode{
    padding: 20px 0;
    text-align: center;
  }
  .fields span{
    display: inline-block;
  }
  .mb_5{
    margin-bottom: 0.3rem;
  }
  .rubrique{
    background: #e0e0e0;
    color: #000;
    text-align:left;
    font-size: 0.7rem;
    font-weight: bold;
    margin: 0;
    padding: 0.3rem;
  }
  .text-center{
    text-align: center;
  }

  table.orders{
    margin: -5px  0 -3px -1px;
  }
  table.orders td{
    border: 1px solid #aaa;
    border-top: 0;
  }
  table.orders tr.last td{
    border-bottom: 0;
  }

  table.orders tr.line td{
    font-size: 0.8rem;
    text-align:right;
    padding: 0.2rem;
  }
  table.orders tr.total td{
    background: #e0e0e0;
  }
  table.b_0 tr td{
    border: none;
  }

  .task span{
    position: relative;
    margin-bottom: 0.7rem;
    display: block;
    padding-left: 2rem;
  }
  .task span::before{
    position: absolute;
    left: 1rem;
    content: "-";
    top: 0;
  }

  .blue-text{
    color: #00b9f6;
  }
  .italic{
    font-style:italic;
  }

  .bullpoint{
    background: #003470;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    color: #fff;
    font-size: 0.4rem;
    line-height: 0.5rem;
    text-align: center;
  }
  .red{
    /* color: red; */
  }
  .cgu{
    padding: 1rem;
    line-height: 1.55;
  }

  .signblock{
    background: pink;
  }

</style>
